
import {
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';

import {
  Router,
  RouterLink,
  RouterLinkActive
} from '@angular/router';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    RouterLink,
    RouterLinkActive
  ],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, OnDestroy {

  menuAberto = false;

  constructor(private router: Router) {}

  ngOnInit(): void {
    // Desktop inicia aberto, celular inicia fechado
    this.menuAberto = window.innerWidth > 900;
    this.atualizarLayout();
  }

  alternarMenu(): void {
    if (window.innerWidth > 900) {
      return;
    }

    this.menuAberto = !this.menuAberto;
    this.atualizarLayout();
  }

  fecharMenu(): void {
    if (window.innerWidth > 900) {
      return;
    }

    this.menuAberto = false;
    this.atualizarLayout();
  }

  private atualizarLayout(): void {
    document.documentElement.classList.toggle(
      'admin-menu-aberto',
      this.menuAberto
    );
  }

  sair(): void {
    localStorage.removeItem('token');
    this.router.navigate(['/admin/login']);
  }

  ngOnDestroy(): void {
    document.documentElement.classList.remove(
      'admin-menu-aberto'
    );
  }
}
